import app from './app.json';
import common from './common.json';
import page from './page.json';
const paPK = {
    app,
    common,
    page
};
export default paPK;
